/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Sort_ZaInputs */

const en_dashboard_sort_za = /** @type {(inputs: Dashboard_Sort_ZaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z–A`)
};

const es_dashboard_sort_za = /** @type {(inputs: Dashboard_Sort_ZaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Z–A`)
};

/**
* | output |
* | --- |
* | "Z–A" |
*
* @param {Dashboard_Sort_ZaInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dashboard_sort_za = /** @type {((inputs?: Dashboard_Sort_ZaInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Sort_ZaInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dashboard_sort_za(inputs)
	return en_dashboard_sort_za(inputs)
});